import { PageFilter } from '../state/app';
import { SquadMemberListFilter } from '../state/squadMember';
import { buildUrlSearchParams } from '../utils/apiRequestUtil';
import axios from '../utils/axios';

const baseUrl = `/api/smSquadMembers`;
export const fetchSquadMemberList = async ({
  filters,
  paging,
}: {
  filters: SquadMemberListFilter;
  paging: PageFilter;
}) => {
  const params = buildUrlSearchParams(filters, paging);
  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};
